"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

/**
 * Renders a link to an external site.
 *
 * @param {string} to An external address to link to. This should
 * be the full domain name of any external site (e.g. https://www.google.com
 * rather than google.com)
 *
 * @example
 * <ExternalLink to="https://www.google.com">Go to Google</ExternalLink>
 */
var ExternalLink = function ExternalLink(_ref) {
  var to = _ref.to;

  // Don't redirect on server-side.
  if (typeof window !== "undefined") {
    window.location.href = to;
  } // Replace the current URL on the history stack so that
  // Chrome & Safari don't behave awkwardly if a user tries
  // to use the back button to return to the site.


  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: "/"
  });
};

var _default = ExternalLink;
exports["default"] = _default;